import { useContext } from 'react';
import { ApplicationContext } from 'context/AppContext';

const useAppContext= () => {
  return useContext(ApplicationContext);
}

export { useAppContext };